import gql from 'graphql-tag'

export const gqlParametrizacao = gql`
  query parametrizacao($parametro: String!) {
    parametrizacao(parametro: $parametro) {
      chave
      valor
    }
  }
`

export const gqlEmailsUsuarios = gql`
  query($parametro: String!, $email: String) {
    emailsUsuarios(parametro: $parametro, email: $email) {
      chave
    }
  }
`



// WEBPACK FOOTER //
// ./src/alelo-logic/services/queries/parameterization.js